"use client"
import { useNavigate } from "react-router-dom"

export default function NotFound() {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate("/")
  }

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="text-center">
        <img src="./prowess-logo.png" alt="prowess Logo" />
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <div className="mb-4">
          <div className="error-divider d-flex align-items-center justify-content-center my-4">
            <div className="border-top border-secondary" style={{ width: "100px" }}></div>
            <span className="mx-3 text-muted">Page Not Found</span>
            <div className="border-top border-secondary" style={{ width: "100px" }}></div>
          </div>
        </div>
        <h2 className="mb-4">We can't seem to find the page you're looking for.</h2>
        <p className="lead mb-5 text-muted">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <div className="d-flex justify-content-center gap-3">
          <button onClick={handleGoBack} className="btn btn-outline-primary px-4">
            Go Back
          </button>
          <button onClick={handleGoHome} className="btn btn-primary px-4">
            Return Home
          </button>
        </div>
      </div>
    </div>
  )
}
